import { Box, Typography } from "@mui/material";
import { useProjectCostGrid } from "../../../hooks/useProjectCostGrid";
import ProjectCostGrid from "../../../components/ProjectCostGrid/ProjectCostGrid";
import ProjectTabSkeleton from "../../../components/ProjectTabSkeleton/ProjectTabSkeleton";
import usePageTitle from "../../../../../Common/hooks/usePageTitle";
import { useSelector } from "react-redux";
import { selectHeiUser } from "../../../../../Auth/store/accountSlice";
import { useMemo } from "react";

interface ProjectCostTabProps {
  id: string;
}

const ProjectCostsTab = ({ id }: ProjectCostTabProps) => {
  const { projectCost, isLoading } = useProjectCostGrid(id);
  const heiUser = useSelector(selectHeiUser);
  const isAdmin = useMemo(
    () => heiUser?.roles?.some((r) => r === "Admin") ?? false,
    [heiUser]
  );
  usePageTitle("Project | Costs");

  if (isLoading) {
    return <ProjectTabSkeleton variant="costs" />;
  }

  return (
    <Box sx={{ pl: "80px", pt: "24px", height: "100%", minHeight: 0, width: "90%", position: "relative" }}>
      <Typography variant={"h6"}>Costs</Typography>
      <Typography variant={"body2"} sx={{ marginBottom: "16px" }}>
        Overview of the estimated costs. To change your billing type, go to the
        Details tab.
      </Typography>
      {projectCost && (
        <ProjectCostGrid
          projectCostResponse={projectCost}
          isLoading={isLoading}
          isAdmin={isAdmin}
        />
      )}
    </Box>
  );
};

export default ProjectCostsTab;
